export var formErrorTheme = {
  baseStyle: {
    text: {
      color: 'critical.main',
      textStyle: 'body4'
    },
    icon: {
      marginEnd: '0.5em',
      color: 'critical.main'
    }
  }
};
//# sourceMappingURL=FormError.theme.js.map